import React, { useEffect, useState } from "react"
import { Button, Card, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { NoteView } from "../../atoms"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants"
import { useSelector } from "react-redux"
import { getDueDateText, stringFormatting, toRupiah } from "../../../app/helpers/TextHelper"
import { timeStampToDate, toMonthYear } from "../../../app/helpers/DateHelper"
import { DATE_TYPE_ENUM } from "../../../constants/StringConstant"

const ModalInvoice = ({ show, setShow }) => {
  const { t } = useTranslation()

  const { Area } = useSelector((state) => state)

  const [areaDebt, setAreaDebt] = useState([])

  useEffect(() => {
    if (Area.areaDebt) {
      setAreaDebt(Area.areaDebt)
    }
  }, [Area.areaDebt])

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      size="md"
      aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <div className="text-uppercase font-weight-bolder txt-14">{t("label_invoice_list")}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column" style={{ gap: 24 }}>
          <div className="px-2">
            <NoteView
              icon={ICON_CONSTANTS.NOTE_VIEW_SUCCESS}
              variant={"success"}
              customMarginClassName="mb-0"
              customVariantClassName="px-4 py-6"
              title={t("messages_info_invoice_sort_by_date")}
              titleClassName={"txt-14 pl-2"}
            />
          </div>
          <div
            className="px-2 d-flex flex-column overflow-auto bg-white"
            style={{ maxHeight: 250, height: "100%", gap: 12 }}>
            {areaDebt?.map((item, i) => (
              <Card className="card-custom" bg={"secondary"} key={i}>
                <Card.Body>
                  <div className="text-neutral-black txt-14">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <div>
                        {item?.is_active_planting_season
                          ? t("label_ongoing_planting_season")
                          : `${toMonthYear(item?.start_date)} - ${toMonthYear(item?.end_date)}`}
                      </div>
                      <div>
                        {stringFormatting(
                          timeStampToDate(item?.due_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center" style={{ gap: 12 }}>
                        <div className="txt-20 font-weight-bolder">
                          {toRupiah(item?.remaining_bill)}
                        </div>
                        {item?.is_draft && (
                          <span className="text-info txt-16">Draft</span>
                        )}
                      </div>
                      <div>{stringFormatting(getDueDateText(item?.days_until_due_date))}</div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </div>
          <Button className={"btn btn-primary w-100 text-uppercase"} onClick={() => setShow(false)}>
            {t("button_oke")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalInvoice
